import axios from "axios";
import create from "zustand";
import { persist } from "zustand/middleware";
import Cookies from "js-cookie";

//#region transcript store
let store = (set) => ({
  // store transcripts
  transcripts: {},
  // store transcripts basd on student
  transcriptsBaseOnStudent: [],
  // store transcripts basd on supervisor
  transcriptsBaseOnSupervisor: {},
  // get All transcripts
  getTranscripts: async () => {
    // setting token
    let token = Cookies.get("token");

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
      params: {
        sortBy: "transcript.id",
        orderBy: "desc",
      },
    };
    // setting url
    // main url comes from .env file
    const apiResponse = await axios.get(
      `${process.env.REACT_APP_API}/transcript`,
      config
    );
    set(async (state) => {
      // initilize transcripts state variable to the responsed transcripts if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.transcripts = apiResponse.data;
    });
  },
  getTranscriptsBaseOnStudent: async (student_code) => {
    // setting token
    let token = Cookies.get("token");

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    // setting url
    // main url comes from .env file
    if (student_code == ".") {
      student_code = "not-exist";
    }
    const apiResponse = await axios.get(
      `${process.env.REACT_APP_API}/transcript/${student_code}`,
      config
    );
    set(async (state) => {
      // initilize transcripts state variable to the responsed transcripts if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.transcriptsBaseOnStudent = apiResponse.data;
    });
  },
  getTranscriptsBaseOnSupervisor: async () => {
    // setting token
    let token = Cookies.get("token");
    const id = Cookies.get("type")?.substring(40)?.split(",")?.[0] ?? -1;

    // attach token to header
    // sort and order data by which column and how
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
      params: {
        sortBy: "transcript.id",
        orderBy: "desc",
      },
    };
    // setting url
    // main url comes from .env file
    const apiResponse = await axios.get(
      `${process.env.REACT_APP_API}/transcript/supervisor/${id}`,
      config
    );
    set(async (state) => {
      // initilize transcripts state variable to the responsed transcripts if request succeed
      if (apiResponse?.status == 200 || apiResponse?.status == 201)
        state.transcriptsBaseOnSupervisor = apiResponse.data;
    });
  },
  addTranscript: async (payload) => {
    // setting token
    let token = Cookies.get("token");

    // attaching token to the header
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    // setting url
    // main url comes from .env file
    const apiResponse = await axios.post(
      `${process.env.REACT_APP_API}/transcript`,
      payload,
      config
    );
    if (apiResponse?.status === 201) {
      set(async (state) => {
        // initilizing transcripts state variable to the resoponsed data
        state.transcripts = {
          data: [apiResponse.data, ...state.transcripts.data],
          limit: state.transcripts.limit,
          page: state.transcripts.page,
          totalCount: state.transcripts.totalCount + 1,
        };
      });
    }
    return apiResponse;
  },
  editTranscript: async (payload, transcript_ids, coursestatuse_ids) => {
    // setting token
    let token = Cookies.get("token");

    // attaching token to the header
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    // setting url
    // main url comes from .env file

    // {{url}}/transcript/?transcript_ids=[7]&coursestatuse_ids=[1]
    // return
    const apiResponse = await axios.patch(
      `${process.env.REACT_APP_API}/transcript?transcript_ids=[${transcript_ids}]&coursestatuse_ids=[${coursestatuse_ids}]`,
      payload,
      config
    );
    // update transcripts state variable if update request was succeed
    if (apiResponse?.status === 200) {
      set(async (state) => {
        // const result = state.transcripts?.data?.find((transcript, index) => {
        //   if (transcript.id === id) {
        //     state.transcripts.data[index] = apiResponse?.data
        //   }
        // })
        // state.transcripts = {
        //   data: [...state.transcripts.data],
        //   limit: state.transcripts.limit,
        //   page: state.transcripts.page,
        //   totalCount: state.transcripts.totalCount,
        // }
      });
    }
    return apiResponse;
  },
  editStandardTranscript: async (payload, id) => {
    // setting token
    let token = Cookies.get("token");

    // attaching token to the header
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    // setting url
    // main url comes from .env file

    const apiResponse = await axios.patch(
      `${process.env.REACT_APP_API}/transcript/edit/${id}`,
      payload,
      config
    );
    // update transcripts state variable if update request was succeed
    if (apiResponse?.status === 200) {
      set(async (state) => {
        const result = state.transcriptsBaseOnSupervisor?.data?.find(
          (transcript, index) => {
            if (transcript.id === id) {
              state.transcriptsBaseOnSupervisor.data[index] = apiResponse?.data;
            }
          }
        );

        // state.transcripts = {
        //   data: [...state.transcriptsBaseOnSupervisor.data],
        //   limit: state.transcriptsBaseOnSupervisor.limit,
        //   page: state.transcriptsBaseOnSupervisor.page,
        //   totalCount: state.transcriptsBaseOnSupervisor.totalCount,
        // }
      });
    }
    return apiResponse;
  },
  deleteTranscript: async (id) => {
    // setting token
    let token = Cookies.get("token");

    // attaching token to the header
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    // setting url
    // main url comes from .env file
    const apiResponse = await axios.delete(
      `${process.env.REACT_APP_API}/transcript/${id}`,
      config
    );
    // delete element in the transcripts.data array state if the request was succeed
    if (apiResponse?.status === 200) {
      set(async (state) => {
        const arr = state.transcripts.data.filter((item) => item.id !== id);
        state.transcripts = {
          data: arr,
          limit: state.transcripts.limit,
          page: state.transcripts.page,
          totalCount: state.transcripts.totalCount - 1,
        };
      });
    }

    return apiResponse;
  },
});
//#endregion transcript store

// store the state in the browser local storage
// store = persist(store, { name: 'transcript' })

// getting store data in the browser localstorage
const transcript_Store = create(store);

export default transcript_Store;
